import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css'; // Re-use landing styles for simplicity

export default function PrivacyPage() {
    return (
        <div className="landing">
            <header className="landing-header">
                <div className="container">
                    <Link to="/" className="logo">🏗️ Wrangler</Link>
                </div>
            </header>

            <main className="container" style={{ padding: '4rem 1rem', maxWidth: '800px' }}>
                <h1 style={{ marginBottom: '2rem' }}>Privacy Policy</h1>
                <p style={{ color: '#666', marginBottom: '2rem' }}>Last updated: January 2026</p>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>1. Introduction</h2>
                    <p>Welcome to Wrangler ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>2. The Data We Collect</h2>
                    <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:</p>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
                        <li><strong>Identity Data:</strong> First name, last name, username.</li>
                        <li><strong>Contact Data:</strong> Billing address, email address, telephone number.</li>
                        <li><strong>Technical Data:</strong> Internet protocol (IP) address, your login data, browser type and version, time zone setting and location.</li>
                        <li><strong>Usage Data:</strong> Information about how you use our website, products and services.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>3. How We Use Your Data</h2>
                    <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
                        <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                        <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                        <li>Where we need to comply with a legal or regulatory obligation.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>4. Data Security</h2>
                    <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>5. POPIA Compliance (South Africa)</h2>
                    <p>In accordance with the Protection of Personal Information Act (POPIA), we act as the "Responsible Party" for your data.</p>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
                        <li><strong>Information Officer:</strong> Legal Team</li>
                        <li><strong>Email:</strong> legal@wranglr.co.za</li>
                        <li><strong>Physical Address:</strong> Johannesburg, South Africa</li>
                    </ul>
                    <p style={{ marginTop: '1rem' }}>You have the right to:</p>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                        <li>Request access to your personal data.</li>
                        <li>Request correction or deletion of your data.</li>
                        <li>Object to the processing of your data.</li>
                        <li>Lodge a complaint with the Information Regulator.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>6. Contact Details</h2>
                    <p>If you have any questions about this privacy policy or our privacy practices, please contact us at: support@wranglr.co.za</p>
                </section>
            </main>

            <footer className="landing-footer">
                <div className="container">
                    <p>© 2026 Wranglr.co.za. Made with ❤️ in South Africa.</p>
                    <div className="footer-links" style={{ justifyContent: 'center', marginTop: '1rem' }}>
                        <Link to="/">Home</Link>
                        <Link to="/terms">Terms</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}
